export const GET_TITLES = 'app/Statistics/GET_TITLES';
export const GET_COMPOSERS = 'app/Statistics/GET_COMPOSERS';
export const GET_CITY_STATS = 'app/Statistics/GET_CITY_STATS';
export const GET_COUNTRY_STATS = 'app/Statistics/GET_COUNTRY_STATS';
export const GET_COMBINED_STATS = 'app/Statistics/GET_COMBINED_STATS';
export const GET_COMBINED_COMPOSERS_STATS = 'app/Statistics/GET_COMBINED_COMPOSERS_STATS';
export const GET_ALL_STATS = 'app/Statistics/GET_ALL_STATS';
